import { Component, State, h, Event, EventEmitter, Element, Prop } from "@stencil/core"
import WaveSurfer from "wavesurfer.js"
import RecordPlugin from "wavesurfer.js/dist/plugins/record.js"
@Component({
  tag: "audio-recorder",
  styleUrls: ["./audio-recorder.css", "../../../../global/tailwind.min.css"],
  shadow: false,
})
export class AudioRecorder {
  @Prop() componentType: string

  @State() isRecording: boolean = false
  @State() time: number = 0
  @State() transcript: string = "" // To store the recognized text
  @State() fullTranscript: string = "" // To store the full transcript

  @Event() startRecord: EventEmitter
  @Event() stopRecord: EventEmitter
  @Event() sendTranscript: EventEmitter

  @Element() element: HTMLElement

  private timer: NodeJS.Timeout
  private recognition: any
  private wavesurfer: WaveSurfer
  private record: any

  async startRecording() {
    this.startRecord.emit(this)
    this.isRecording = true

    try {
      this.startRecognition()

      setTimeout(() => this.createWaveSurfer(), 500)

      this.time = 0
      this.timer = setInterval(() => {
        this.time++
      }, 500)
    } catch (error) {
      console.error("Error accessing microphone:", error)
    }
  }
  createWaveSurfer() {
    // Destroy the previous wavesurfer instance
    if (this.wavesurfer) {
      this.wavesurfer.destroy()
    }

    // console.log("Creating new Wavesurfer instance", this.element.querySelector("#mic"))
    // Create a new Wavesurfer instance
    this.wavesurfer = WaveSurfer.create({
      container: this.element.querySelector("#mic") as HTMLElement,
      waveColor: "#007bff",
      progressColor: "#007bff",
      barWidth: 3, // Small bar width
      barGap: 2, // Slight gap between bars
      height: 30,
      plugins: [
        RecordPlugin.create({
          scrollingWaveform: true,
        }),
      ],
    })
    this.record = this.wavesurfer.getActivePlugins()[0]
    this.record.startRecording()
  }

  startRecognition() {
    if ("SpeechRecognition" in window || "webkitSpeechRecognition" in window) {
      const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition
      this.recognition = new SpeechRecognition()
      this.recognition.lang = "en-US" // Set the language for recognition
      this.recognition.interimResults = true // Only get final results

      // Start recording
      this.recognition.start()

      // Capture the result when speech is recognized
      this.recognition.onresult = (event: any) => {
        let transcript = ""
        for (let i = event.resultIndex; i < event.results.length; i++) {
          transcript += event.results[i][0].transcript
        }

        this.fullTranscript = transcript // Store the full transcript

        console.log("Recognized Speech: ", this.fullTranscript)
        this.transcript = this.fullTranscript
        // this.sendTranscript.emit(transcript)
      }

      // Handle errors (e.g., no speech, microphone access issues)
      this.recognition.onerror = (event: any) => {
        console.error("Error occurred in recognition:", event.error)
      }

      // Stop recording automatically after speech ends
      this.recognition.onend = () => {
        // this.isRecording = false
        // this.isListening = false
        // this.endTranscript.emit(this.fullTranscript)
      }
    } else {
      alert("Speech Recognition API is not supported in your browser.")
    }
  }

  stopRecording(source: string) {
    this.stopRecord.emit(this)

    if (source === "stop") {
      this.sendTranscript.emit(this.fullTranscript)
    }

    this.record.stopRecording()

    // Stop speech recognition
    if (this.recognition) {
      this.recognition.stop()
    }

    this.isRecording = false

    clearInterval(this.timer)
  }

  render() {
    const minutes = Math.floor(this.time / 60)
    const seconds = this.time % 60

    return (
      <div class="flex w-full">
        {/* Recording UI */}
        {this.isRecording && (
          <div class={`relative flex items-center w-full max-w-3xl rounded-full`}>
            {/* Cancel Button */}
            {this.isRecording && (
              <button
                onClick={e => {
                  e.preventDefault()
                  this.stopRecording("cancel")
                }}
                class="w-10 h-10 rounded-full  flex items-center justify-center text-white"
              >
                ❌
              </button>
            )}
            <div id="mic" style={{ width: "100%" }}></div>
            {/* {this.showWaveform && <canvas ref={el => (this.canvasRef = el)} class="w-full h-10" />} */}

            {/* Timer */}
            {this.isRecording ? (
              <div class="ml-auto text-blue-600 font-semibold">
                {String(minutes).padStart(2, "0")}:{String(seconds).padStart(2, "0")}
              </div>
            ) : null}

            {/* Confirm Button */}
            {this.isRecording && (
              <button
                onClick={e => {
                  e.preventDefault()
                  this.stopRecording("stop")
                }}
                class="w-10 h-10 text-blue-600 ml-2 rounded-full  flex items-center justify-center"
              >
                <span class="text-blue-600 font-sans">✔</span>
              </button>
            )}
          </div>
        )}

        {/* Mic Button */}
        {!this.isRecording && (
          <button
            onClick={e => {
              e.preventDefault()
              this.startRecording()
            }}
            class={`flex ${this.componentType === "search" ? "p-1.5 mr-0.5 self-center mt-0.5" : "w-10 h-8 p-0 mt-4"}`}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class={`w-5 h-5 translate-y-[0.5px] ${this.componentType === "search" ? "mic-icon" : "mic-botIcon"}`}>
              <path d="M7 4a3 3 0 016 0v6a3 3 0 11-6 0V4z"></path>
              <path d="M5.5 9.643a.75.75 0 00-1.5 0V10c0 3.06 2.29 5.585 5.25 5.954V17.5h-1.5a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-1.5v-1.546A6.001 6.001 0 0016 10v-.357a.75.75 0 00-1.5 0V10a4.5 4.5 0 01-9 0v-.357z"></path>
            </svg>
          </button>
        )}
      </div>
    )
  }
}
